import React, { useEffect, useState } from 'react';
import Home from './components/Home';
import { Toaster, toast } from 'react-hot-toast';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ProductDetails from './components/products/ProductDetails';
import Wrapper from './components/Wrapper';
import Products from './components/products/Products';
import RegisterLogin from './components/user/RegisterLogin';
import UserAccount from './components/user/UserAccount';
import store from './redux/store';
import { loadUser } from './redux/actions/userAction';
import { useDispatch, useSelector } from 'react-redux';
import ProtectedRoute from './components/route/ProtectedRoute';
import UpdateProfile from './components/user/UpdateProfile';
import ChangePassword from './components/user/ChangePassword';
import UserOptions from './components/common/UserOptions';
import Contact from './components/common/Contact.jsx';
import ForgotPassword from './components/user/ForgotPassword';
import ResetPassword from './components/user/ResetPassword';
import Cart from './components/cart/Cart';
import Shipping from './components/cart/Shipping';
import ConfirmOrder from './components/cart/ConfirmOrder';
import Payment from './components/cart/Payment';
import axios from 'axios';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import OrderSuccess from './components/cart/OrderSuccess';
import MyOrders from './components/cart/MyOrders';
import OrderDetails from './components/cart/OrderDetails';
import Dashboard from './components/admin/Dashboard';
import ProductList from './components/admin/ProductList';
import CreateProduct from './components/admin/CreateProduct';
import UpdateProduct from './components/admin/UpdateProduct';
import OrderList from './components/admin/OrderList';
import ProcessOrder from './components/admin/ProcessOrder';
import UserList from './components/admin/UserList';
import UpdateUser from './components/admin/UpdateUser';
import ProductReviews from './components/admin/ProductReviews';
import Cookies from 'universal-cookie';

const getHeader = () => {
    return { headers: { Authorization: new Cookies().get('token') } };
};

export const URL = 'https://ship-shop-server.vercel.app';
// export const URL = 'http://localhost:4008';

const Routing = () => {
    const { isAuthenticated, user } = useSelector((state) => state.user);
    const [stripeApiKey, setStripeApiKey] = useState('');

    const navigate = useNavigate();

    const getStipeApiKey = async () => {
        if (stripeApiKey) return;
        const { data } = await axios.get(`${URL}/api/v1/stripeapikey`, getHeader());
        setStripeApiKey(data.stripeApiKey);
    };

    useEffect(() => {
        store.dispatch(loadUser());
    }, []);

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/');
            return;
        }
        if (!stripeApiKey) {
            getStipeApiKey();
        }
    }, [store, isAuthenticated]);

    const getRoutes = () => {
        if (!isAuthenticated) {
            return;
        }
        return (
            <>
                <Route path='account' element={<UserAccount />} />
                <Route path='me/update' element={<UpdateProfile />} />
                <Route path='password/update' element={<ChangePassword />} />
                <Route path='shipping' element={<Shipping />} />
                <Route path='order/confirm' element={<ConfirmOrder />} />
                <Route path='success' element={<OrderSuccess />} />
                <Route path='orders' element={<MyOrders />} />
                <Route path='order/:id' element={<OrderDetails />} />
            </>
        );
    };
    const getAdminRoutes = () => {
        return (
            user &&
            user.role === 'admin' && (
                <>
                    <Route path='admin/dashboard' element={<Dashboard />} />
                    <Route path='admin/products' element={<ProductList />} />
                    <Route path='admin/product' element={<CreateProduct />} />
                    <Route path='admin/product/:id' element={<UpdateProduct />} />
                    <Route path='admin/orders' element={<OrderList />} />
                    <Route path='admin/order/:id' element={<ProcessOrder />} />
                    <Route path='admin/users' element={<UserList />} />
                    <Route path='admin/user/:id' element={<UpdateUser />} />
                    <Route path='admin/reviews' element={<ProductReviews />} />
                </>
            )
        );
    };

    return (
        <>
            {isAuthenticated && <UserOptions user={user} />}
            <Routes>
                <Route path='/' element={<Wrapper />}>
                    <Route index element={<Home />} />
                    <Route path='login' element={<RegisterLogin />} />
                    <Route path='password/forgot' element={<ForgotPassword />} />
                    <Route path='password/reset/:token' element={<ResetPassword />} />
                    <Route path='product/:id' element={<ProductDetails />} />
                    <Route path='products' element={<Products />} />
                    <Route path='products/:keyword' element={<Products />} />
                    <Route path='cart' element={<Cart />} />
                    <Route path='contact' element={<Contact />} />
                    {getRoutes()}
                    {isAuthenticated && getAdminRoutes()}
                </Route>
                {/* <Route path='*' element={<Home />} /> */}
            </Routes>
            <aside>
                {isAuthenticated && stripeApiKey && (
                    <Elements stripe={loadStripe(stripeApiKey)}>
                        <Routes>
                            <Route
                                path='/process/payment'
                                element={
                                    isAuthenticated === false ? (
                                        <Navigate to='/login' />
                                    ) : (
                                        <Payment />
                                    )
                                }
                            />
                        </Routes>
                    </Elements>
                )}
            </aside>
            <Toaster position='top-center' />
        </>
    );
};

export default Routing;
